module.exports = __webpack_public_path__ + "img/pattern2.3b9bdd3.svg";